import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { useDropzone } from 'react-dropzone';
import { Add, Check } from '@material-ui/icons';
import { List, ListItem, Paper } from '@material-ui/core';
import * as api from '../../../api/api';
import Popover from '@material-ui/core/Popover';
import Axios from 'axios';
import { Document, Page, Image } from 'react-pdf';
import FileViewer from "react-file-viewer";
import FilePreview from './FilePreview';
import axios from 'axios'

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15)
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20
  },
  details: {
    alignItems: 'center'
  },
  column: {
    // flexBasis: '33.33%',
    flexBasis: '95%'
  },
  column1: {
    flexBasis: '66.6%'
  },
  column2: {
    flexBasis: '33.33%'
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2)
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    },
    preview: {
      width: '10%'
    }
  }
}));

export default function DetailedExpansionPanel(props) {
  const classes = useStyles();
  const [files, setFiles] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [filePreview, setFile] = React.useState({
    fileName: '',
    type: '',
    file: ''
  });



  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    accept: '.jpeg,.png,.jpg,.pdf,.ecp',
    onDrop: acceptedFiles => {
      //   setFiles(acceptedFiles);
      handleSave(acceptedFiles);
    }
  });

  const style = React.useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject]
  );

  const handleDelete = async path => {
    // setFiles(chips => chips.filter(chip => chip !== path));

    const data = {
      id: props.id,
      file: path
    };
    props.typeAction('REQUEST_DEL_FILE');
    try {
      await api.delFile(data);
      props.setFilesAction(props.id);
      props.apllicantData(props.id);
      props.typeAction('SUCCESS_DEL_FILE');
    } catch (error) {
      props.typeAction('FAILURE_DEL_FILE');
    }
  };


  const previewFile = async (event, file) => {
    
    const type = file.split(".").pop();

    
    // setFile(prev => ({fileName: `/fop/file/${file}`, type}));
    // handleClickOpen()



    try {
      const response = await axios.get(`/fop/file/${file}`, {
        responseType: type === 'pdf' ? 'blob' : 'arraybuffer',
      });
      const image = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const base64Image = `data:${response.headers['content-type'].toLowerCase()};base64,${image}`;
      
      setFile(prev => ({fileName: type === 'pdf' ? url : base64Image, type, file}));
      handleClickOpen();
    } catch (error) {

    }
    
    // getFile(file);
  };

  const thumbs = files.map(file => (
    <ListItem key={file}>
      {/* {file.path} - {file.size} bytes */}
      <Chip
        // icon={icon}
        label={file}
        onDelete={() => handleDelete(file)}
        className={classes.chip}
        variant="outlined"
        color="primary"
        size="small"
        clickable
        onClick={e => previewFile(e, file)}
      />
    </ListItem>
  ));

  React.useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks
    // files.forEach(file => URL.revokeObjectURL(file.preview));
    setFiles(props.item.files);
  }, [props.item.files]);

  function clearFiles() {
    setFiles([]);
  }

  async function handleSave(files) {
    const data = {
      id: props.id,
      doctype: props.item.id,
      comment: ''
    };
    var formData = new FormData();
    files.forEach((item, i) => {
      formData.append('file', item);
    });
    formData.append('data', JSON.stringify(data));
    props.typeAction('REQUEST_SAVE_FILE');
    try {
      await api.saveFiles(formData);
      props.setFilesAction(props.id);
      props.typeAction('SUCCESS_SAVE_FILE');
      props.apllicantData(props.id);
    } catch (error) {
      props.typeAction('FAILURE_SAVE_FILE');
    }
  }



  return (
    <Grid item xs={12} md={6}>
      <div className={classes.root}>
        <ExpansionPanel defaultExpanded>
          <Paper variant="outlined" square>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1c-content"
              id="panel1c-header"
            >
              <div className={classes.column}>
                <Typography
                  component="h4"
                  variant="h4"
                  className={classes.heading}
                >
                  {props.item.name}
                </Typography>
              </div>
              {/* <div className={classes.column2}> */}
                {/* <Typography className={classes.secondaryHeading}>Оберіть файли</Typography> */}
              {/* </div> */}
            </ExpansionPanelSummary>
          </Paper>
          <ExpansionPanelDetails className={classes.details}>
            {/* <div className={classes.column} /> */}
            <div className={classes.column1}>
              {/* <Chip label="Barbados" onDelete={() => {}} /> */}
              <div {...getRootProps({ style })} className="mr-2">
                <input {...getInputProps()} />
                {isDragActive ? (
                  <>
                  <p>Оберіть файли тут ...</p>
                  <p>максимальний розмір файлу 8 Мб</p>
                  </>
                ) : (
                  <>
                  <p className="text-center">Перетягніть файли або натисніть, щоб вибрати файли</p>
                  <p className="text-center">максимальний розмір файлу 8 Мб</p>
                  </>
                )}
              </div>
            </div>
            <div className={clsx(classes.column2, classes.helper)}>
              <Typography variant="caption">
                Завантажені файли
                <br />
                <List>{thumbs}</List>
              </Typography>
            </div>
          </ExpansionPanelDetails>
          {/* <Divider />
          <ExpansionPanelActions>
            <Button size="small" onClick={clearFiles}>
              Cancel
            </Button>
            <Button
              size="small"
              color="primary"
              onClick={() => handleSave(props.item.id)}
            >
              Зберегти
            </Button>
          </ExpansionPanelActions> */}
        </ExpansionPanel>
      </div>
      <FilePreview open={open} onClose={handleClose} classes={classes} filePreview={filePreview} />
    </Grid>
  );
}
